import { Typography, RadioGroup, FormControlLabel, Radio, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { TipoProposta } from "src/components/projetos/types";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { isLoading$ } from "src/framework/store/ApiEvents";
import { notifierStore } from "src/framework/store/NotifierStore";
import theme from "src/theme/light";

interface KitConfirmationModalProps {
  onConfirm: (tipoProposta: TipoProposta, emailProposta: any) => void 
  isOpened: boolean;
  close: () => void;
  showPropostaOptions?: boolean;
  emailPropostaOriginal: any;
}

export function KitConfirmationModal({ onConfirm, close, isOpened, showPropostaOptions = true, emailPropostaOriginal }: KitConfirmationModalProps){
  const [tipoProposta, setTipoProposta] = useState<TipoProposta|any>(null)
  const [emailProposta, setEmailProposta] = useState<any>(null);
  const [errorEmail, setErrorEmail] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const FooterBottom = isMobile ? Box : DialogActions;
  
  const validateEmail = (email: string) => {
      return !!String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
  };
  const validate = (): boolean => {
      const messages: string[] = [];
      
      if (!emailProposta) {
          setErrorEmail(true)
          messages.push('O campo "E-mail do cliente pagador" é obrigatório!');
      }else if(!validateEmail(emailProposta)){
          setErrorEmail(true);
          messages.push('O e-mail informado é inválido!');
      }
      if (!tipoProposta){
          messages.push("É necessário selecionar a proposta à ser enviada por e-mail!")
      }
      if (messages.length > 0) {
        notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
            notifierStore.setOpen(false)
          }
        })
        notifierStore.setOpen(true)
        return false;
      }
      return messages.length === 0;
  }
  useEffect(()=>{
    if (isOpened){
      isLoading$.next(false);
    }
    if(emailPropostaOriginal){
      setEmailProposta(emailPropostaOriginal)
    }
  },[isOpened])
  return (
    <Dialog
        open={isOpened}
        onClose={close}
        className={"modal-enviar-pagamento"}
      >
      <DialogTitle>
        <Typography variant="h5" color="textPrimary">
          Atenção!
        </Typography>
      </DialogTitle>
      <DialogContent
        style={{ minWidth: "300px" }}
      >
        <DialogContentText>
        <Typography variant="body2">
          Após enviar para pagamento:
        </Typography>

        <ul>
          <li>
            <Typography variant="body2">
              O projeto não poderá ser alterado.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              O link para acessar o Portal de Pagamentos será enviado para o e-mail do cliente.
            </Typography>
          </li>
        </ul>

        <>
          <Typography variant="body2">
            Tipo de proposta a ser enviada para o cliente:
          </Typography>

          <RadioGroup
            row
            className="radio-group-enviar-pagamentos"
            style={{ marginTop: "16px", display: "flex", justifyContent: "space-evenly", alignItems: "center" } }
            value={tipoProposta}
            onChange={(event: any) => {
              const value = event.target.value as TipoProposta
              setTipoProposta(value)
            }}
            aria-label="tipo-proposta"
            name="tipo-proposta"
            defaultValue={tipoProposta}>
                <FormControlLabel
                  value={'simplificada'}
                  control={<Radio color="primary" />}
                  label={<Typography style={{fontSize: "14px"}}>Proposta simplificada</Typography>}
                />
                {showPropostaOptions && (
                  <FormControlLabel
                    value={'detalhada'}
                    control={<Radio color="primary" />}
                    label={<Typography style={{fontSize: "14px"}}>Proposta detalhada</Typography>}
                  />
                )}
                <FormControlLabel
                  value={'link'}
                  control={<Radio color="primary" />}
                  label={<Typography style={{fontSize: "14px"}}>Enviar apenas o link</Typography>}
                />
          </RadioGroup>
        </>
        <h4>Informe o e-mail que receberá os dados para pagamento:</h4>
          <InputText label="* E-mail do cliente pagador" fullWidth
              value={emailProposta}
              error={errorEmail}
              helperText={errorEmail ? "E-mail inválido" : ''}
              inputProps={{
                  autocomplete: 'off',
              }}
              onChange={(e: any) => {
                  setEmailProposta(e.target.value);
              }}
              onKeyDown={(e: any) => {
                  const spaceRegex = /\s/g
                  e.target.value = e.target.value.replace(spaceRegex, '')
              }}
              onKeyUp={(e: any) => {
                  if (e.target.value !== "") {
                      let erro = false;
                      if (ValidateUtil.isValidEmail(e.target.value) && validateEmail(e.target.value)) {
                          erro = false;
                      } else {
                          erro = true;
                      }
                      setErrorEmail(erro);
                  }
              }}
          />
        </DialogContentText>
      </DialogContent>
      <FooterBottom className="footer-enviar-pagamento" style={isMobile ? { display: "flex", flexDirection: "column-reverse", width: "100%", padding: "0px 25px 15px 25px" } : {}}>
        <FlatButton
          variant="outlined"
          onClick={close}
          color="secondary"
          text={"Cancelar"}
          fullWidth={isMobile}
        />
        <FlatButton
          onClick={() => {
            if(!validate()){
              return;
            }
            isLoading$.next(true);
            onConfirm(tipoProposta, emailProposta);
          }}
          color="primary"
          variant="contained"
          text={"Confirmar"}
          fullWidth={isMobile}
          disabled={errorEmail}
        />
      </FooterBottom>
    </Dialog>
  );
}